import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Style from 'style-it';
import * as styles from './ButtonBar.scss';
var ButtonBar = (_dec = connect(function (state) {
  return {
    theme: state.theme
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(ButtonBar, _Component);

  var _super = _createSuper(ButtonBar);

  function ButtonBar() {
    var _this;

    _classCallCheck(this, ButtonBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (item) {
      if (item) {
        if (_this.props.onChange) {
          // for redux form
          _this.props.onChange(item);
        }

        if (_this.props.onTabClick) {
          _this.props.onTabClick(item);
        }
      }
    });

    return _this;
  }

  _createClass(ButtonBar, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _float = this.props.vertical ? 'none' : 'left';

      var tabs;

      if (this.props.selected) {
        tabs = this.props.items.map(function (item, index) {
          var selected = item.key === _this2.props.selected;
          var className = selected ? "".concat(styles.tab, " ").concat(styles.activetab) : "".concat(styles.tab);
          var style = selected ? {
            backgroundColor: _this2.props.theme.colors.secondaryColor,
            "float": _float,
            borderLeft: '1px solid #dfdfdf'
          } : _this2.props.vertical ? {
            "float": _float,
            borderLeft: '1px solid #dfdfdf'
          } : {};
          return /*#__PURE__*/React.createElement(Style, {
            key: index
          }, "\n            .buttonBarItemInline:hover {\n              background-color: ".concat(_this2.props.theme.colors.secondaryColor, ";\n            }\n          "), /*#__PURE__*/React.createElement("li", {
            className: "".concat(className, " buttonBarItemInline"),
            style: style,
            onClick: function onClick() {
              return _this2.handleClick(item);
            }
          }, item.icon ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
            className: "fa ".concat(item.icon)
          }), "\xA0") : null, item.title));
        });
      } else {
        tabs = this.props.items.map(function (item, index) {
          var className = item.selected ? "".concat(styles.tab, " ").concat(styles.activetab) : "".concat(styles.tab);
          var style = item.selected ? {
            backgroundColor: _this2.props.theme.colors.secondaryColor,
            "float": _float,
            borderLeft: '1px solid #dfdfdf'
          } : _this2.props.vertical ? {
            "float": _float,
            borderLeft: '1px solid #dfdfdf'
          } : {};
          return /*#__PURE__*/React.createElement(Style, {
            key: index
          }, "\n            .buttonBarItemInline:hover {\n              background-color: ".concat(_this2.props.theme.colors.secondaryColor, ";\n            }\n          "), /*#__PURE__*/React.createElement("li", {
            className: "".concat(className, " buttonBarItemInline"),
            style: style,
            onClick: function onClick() {
              return _this2.handleClick(item);
            }
          }, item.icon ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
            className: "fa ".concat(item.icon)
          }), "\xA0") : null, item.title));
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: this.props["class"] ? this.props["class"] : ''
      }, /*#__PURE__*/React.createElement("ul", {
        className: styles.wrap,
        style: this.props.style
      }, tabs), this.props.children);
    }
  }]);

  return ButtonBar;
}(Component), _defineProperty(_class2, "propTypes", {
  items: PropTypes.array.isRequired,
  theme: PropTypes.object.isRequired,
  style: PropTypes.object,
  onChange: PropTypes.func,
  onTabClick: PropTypes.func,
  children: PropTypes.node
}), _temp)) || _class);
export { ButtonBar as default };
ButtonBar.defaultProps = {
  "class": 'col-xs-12'
};